import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { environment } from '@env/environment';
import { ScaffoldDialogRef } from "@app/framework/dialog/scaffold-dialog.service";
import { GraphsService } from '@services/graphs.service';
import { HttpUtilService } from '@services/http-util.service';
@Component({
  selector: 'app-htmlmodal',
  templateUrl: './htmlmodal.component.html',
  styleUrls: ['./htmlmodal.component.scss']
})
export class HTMLModalComponent implements OnInit, AfterViewInit {

  @ViewChild("contentHolder", { static: false }) private itemElements: ElementRef;
  data: any = {};
  constructor(private http: HttpUtilService, private graphService: GraphsService, private element: ElementRef, public dialogRef: ScaffoldDialogRef) { }
  url = environment.apiRoot + '/download/pdf';
  ngOnInit() {
  }

  ngAfterViewInit() {
   /* this.itemElements.changes.subscribe(() => {
      console.log("Item elements are now in the DOM!", this.itemElements.length);
      const htmlElement = document.getElementById(this.selectedItemId);
    
  });*/
    let items = document.getElementsByClassName("graph_item")
    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      let settings, values;
      try {
        settings = JSON.parse(item.firstChild.textContent);
        item.innerHTML = "";
      } catch (e) {
        console.log(e)
      }
      console.log(settings)
      values = settings.data_items.map(v => {
        console.log(v.value);
        return parseInt(v.value);
      });
      this.graphService.generatePie(items[i], values, settings)
    }
    console.log(items);
  }

  getPDF(content: string) {
    content = this.itemElements.nativeElement.innerHTML;
    let styles = '<link rel="stylesheet" href="https://k16-hosted-lib.s3.us-east-2.amazonaws.com/bootstrapCanvas/pdf_main.css">';
    content = content.replace(/\n/g, "");
    this.http.request('post',environment.apiRoot + '/download/pdf', { html: styles + content ,name:this.data.title || this.data.type},null,true).subscribe(data => {
      window.open(data['url'], "_blank");
    });
  }

}
